import { render, staticRenderFns } from "./HealthAccount.vue?vue&type=template&id=8211c29a&"
import script from "./HealthAccount.vue?vue&type=script&lang=js&"
export * from "./HealthAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports